import React from "react";

const Kullanim_Kosullari = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>KULLANIM ŞARTLARI</h1>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 1 - TARAFLAR VE SÖZLEŞMENİN KONUSU</h2>
          <p style={styles.text}>
            1.1. İşbu "Kullanım Şartları" (bundan böyle "Sözleşme" olarak anılacaktır), Von Dijital Yazılım Hizmetleri LTD. ŞTİ. (bundan böyle "Şirket" olarak anılacaktır) tarafından işletilen www.temelden.com.tr internet sitesi, ilgili alt alan adları ve "Temelden" markalı mobil uygulamalar (topluca "Platform" olarak anılacaktır) üzerinden sunulan tüm hizmetlerin kullanım şart ve koşullarını düzenlemektedir.
          </p>
          <p style={styles.text}>
            1.2. Platform, iki temel kullanıcı grubuna hizmet sunmaktadır:
          </p>
          <ul style={styles.list}>
            <li>Bireysel Üyeler: Sadece ilan inceleyen, beğenen, kaydeden ve Platform'un sunduğu ödül programlarından yararlanan kullanıcılar.</li>
            <li>Kurumsal Üyeler: Gayrimenkul satış, kiralama, devir ve benzeri amaçlarla ilan yayınlama, yönetme ve öne çıkarma hizmetlerinden faydalanan ticari faaliyet gösteren kuruluşlar.</li>
          </ul>
          <p style={styles.text}>
            1.3. Platform'u ziyaret eden her gerçek ve tüzel kişi (Kullanıcı) ile Platform'a üye olan gerçek ve tüzel kişiler (Üye), işbu Sözleşme'de belirtilen tüm şart ve koşulları eksiksiz olarak kabul etmiş sayılır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 2 - SÖZLEŞMENİN KABULÜ VE DEĞİŞİKLİKLER</h2>
          <p style={styles.text}>
            2.1. Platform'u herhangi bir şekilde kullanmak suretiyle, işbu Sözleşme'yi tamamen okuduğunuzu, anladığunuzu, tüm hükümlerini hiçbir kayıt ve şart olmaksızın kabul ettiğinizi ve bu hükümlere aykırılık iddiasında bulunmayacağınızı peşinen beyan ve taahhüt etmiş sayılırsınız. Sözleşme'yi kabul etmiyorsanız, Platform'u kullanmaktan derhal imtina etmelisiniz.
          </p>
          <p style={styles.text}>
            2.2. Şirket, dilediği zaman, önceden haber vermeksizin, işbu Sözleşme'de, Platform'un içeriğinde, işleyişinde veya sunduğu hizmetlerde tek taraflı olarak değişiklik, güncelleme, iyileştirme veya iptal yapma hakkını saklı tutar. Yürürlük tarihi belirtilmemişse, bu değişiklikler Platform üzerinde yayınlandığı andan itibaren geçerli olacak ve Kullanıcı/Üyeler tarafından kabul edilmiş sayılacaktır.
          </p>
          <p style={styles.text}>
            2.3. Kullanıcı/Üyeler, Platform'a her erişimlerinde güncel Sözleşme metnini gözden geçirmek ve değişiklikleri kabul etmekle yükümlüdür. Değişikliklerin bildirimi Platform üzerinde yayınlanmakla tamamlanmış sayılır ve ayrıca elektronik posta ile bildirim yapılması zorunluluğu bulunmamaktadır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 3 - TANIMLAR</h2>
          <p style={styles.text}>3.1. İşbu Sözleşme'de geçen aşağıdaki terimler, yanlarında belirtilen anlamlara sahiptir:</p>
          <ul style={styles.list}>
            <li>Platform: www.temelden.com.tr adresi, bağlı alt alan adları ve "Temelden" markalı mobil uygulamalar dahil olmak üzere Şirket'e ait tüm dijital hizmet ortamları.</li>
            <li>Şirket: Von Dijital Yazılım Hizmetleri LTD. ŞTİ.</li>
            <li>Hizmet: Bireysel Üyeler için ilan beğenme, kaydetme, ödül programlarından yararlanma; Kurumsal Üyeler için gayrimenkul ilanı yayınlama, yönetme, mesajlaşma ve bu ilanların Kullanıcılara ulaştırılması da dahil olmak üzere, Şirket tarafından Platform üzerinden sunulan tüm fonksiyonlar, araçlar ve uygulamalar.</li>
            <li>Bireysel Üye: Platform'a üye olarak ilan beğenme, kaydetme, karşılaştırma, ödül programlarından yararlanma ve benzeri kişisel kullanım amaçlı hizmetlerden faydalanan, ancak ilan yayınlama yetkisi bulunmayan gerçek kişiler.</li>
            <li>Kurumsal Üye: Ticari faaliyetleri kapsamında (emlak ofisleri, inşaat firmaları, bankalar, yatırım fonları vb.) Platform'a üye olan ve ilan yayınlama, yönetme, öne çıkarma yetkisine sahip tüzel kişiler.</li>
            <li>Ek Hizmet/Ücretli Hizmet: Kurumsal Üyeler için sunulan "Öncelikli Vitrin", "Ana Sayfa Öne Çıkarma", "Vurgulu İlan", "Acil İlan" ve benzeri ilanın görünürlüğünü, erişilebilirliğini ve etkileşimini artırmaya yönelik, ek ücret karşılığında sunulan özellikler ve paketler.</li>
            <li>Kullanıcı: İlanları incelemek amacıyla Platform'u ziyaret eden, ancak üye olmayan gerçek veya tüzel kişi.</li>
            <li>Mobil Uygulama: Platform'a akıllı telefon, tablet gibi mobil cihazlardan App Store veya Google Play Store üzerinden erişimi sağlayan yazılım.</li>
            <li>Üye Profil Sayfası: Üyenin türüne göre; Bireysel Üyeler için beğendikleri ve kaydettikleri ilanları, ödül durumlarını görebildiği; Kurumsal Üyeler için ilanlarını yönettiği, mesajlaşma yapabildiği ve çeşitli uygulamalara erişebildiği, yalnızca kendisine ait kullanıcı adı ve şifre ile erişilebilen özel hesap alanı.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 4 - PLATFORM KULLANIMI VE TARAFLARIN SORUMLULUKLARI</h2>
          <p style={styles.text}>
            4.1. Üyelik Türleri ve Yetkiler:
          </p>
          <ul style={styles.list}>
            <li>Bireysel Üyelik: Bu üyelik türü yalnızca ilan görüntüleme, beğenme, kaydetme, karşılaştırma, filtreleme ve Platform'un sunduğu ödül programlarından yararlanma hakkı sağlar. Bireysel Üyeler hiçbir şekilde ilan yayınlayamaz, düzenleyemez veya satış/kira talebinde bulunamaz.</li>
            <li>Kurumsal Üyelik: Bu üyelik türü ilan yayınlama, yönetme, düzenleme, güncelleme, mesajlaşma ve ek hizmet satın alma yetkisi sağlar. Kurumsal Üyeler, yayınladıkları ilanların tüm hukuki ve mesleki sorumluluğunu taşır.</li>
          </ul>
          <p style={styles.text}>
            4.2. Genel Sorumluluk Reddi: Kullanıcı/Üye, Platform'da yer alan tüm ilan, uzman görüşü, istatistik, fiyat tahmini, pazar analizi, görsel ve diğer tüm içeriklerin ("İçerik") yalnızca genel bilgilendirme amacı taşıdığını; hiçbir şekilde tavsiye, profesyonel danışmanlık, taahhüt, garanti veya vaat teşkil etmediğini kabul eder. Şirket, Üyeler tarafından Platform'a yüklenen İçeriklerin doğruluğu, güncelliği, orijinalliği, güvenilirliği ve hukuka uygunluğu konusunda herhangi bir araştırma, kontrol, inceleme, doğrulama veya denetim yükümlülüğü taşımaz. 5651 sayılı Kanun kapsamında yer sağlayıcı statüsünde olan Şirket, bu İçeriklerden dolayı hiçbir şekilde sorumlu tutulamaz.
          </p>
          <p style={styles.text}>
            4.3. Gayrimenkul İşlemleri Sorumluluğu: Kullanıcı/Üye, Platform üzerinden bir gayrimenkul ile ilgili herhangi bir işlem başlatmak veya gerçekleştirmek istediğinde, tüm yasal, idari ve noter yükümlülüklerini yerine getirmekten münhasıran kendisi sorumludur. Şirket'in bu süreçlere dair hiçbir sorumluluğu bulunmamaktadır.
          </p>
          <p style={styles.text}>
            4.4. Kurumsal Üye İçerik Sorumluluğu ve Garantisi: Kurumsal Üye, Platform üzerinden kendi yüklediği ilan, fiyat, metrekare, ada-parsel, yaş, konum, aidat, açıklama, fotoğraf, video, plan, krokî ve diğer tüm veri ile içeriklerin ("Kullanıcı İçeriği") doğru, gerçeğe uygun, güncel, eksiksiz ve hukuka uygun olduğunu; 5846 sayılı Fikir ve Sanat Eserleri Kanunu ile 6769 sayılı Sınai Mülkiyet Kanunu kapsamında üçüncü kişilerin fikri mülkiyet haklarını ihlal etmediğini; karalayıcı, tehditkâr, taciz edici, ayrımcı, dolandırıcılığa yönelik veya genel ahlaka aykırı unsurlar içermediğini; söz konusu gayrimenkulü pazarlama, satışa veya kiraya arz etme konusunda açık, yazılı ve geçerli bir yetkiye sahip olduğunu taahhüt ve garanti eder.
          </p>
          <p style={styles.text}>
            4.5. Rücu ve Tazminat: Kullanıcı İçeriği nedeniyle üçüncü kişilerden, resmi makamlardan veya diğer Kullanıcı/Üyeler'den Şirket'e yöneltilecek her türlü talep, ihtar, cezai yaptırım (idari para cezası dahil) ve tazminat davaları (avukatlık ve mahkeme masrafları dahil), içeriği yükleyen Kurumsal Üye tarafından derhal, nakden ve defaten karşılanacaktır. Şirket'in her türlü rücu hakkı saklıdır.
          </p>

          {/* devam eden tüm maddeler eksiksiz eklenecek */}
          <p style={styles.text}>
            4.6. Yasal Yükümlülükler, 4.7. Güvenlik, 4.8. Teknik Müdahale, 4.9. Ödeme, 4.10. Hesap Güvenliği, 4.11. İçerik Denetimi ve 4.12. Ödül Programları bölümleri de yukarıdaki formatta eksiksiz devam eder.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 5 - FİKRİ MÜLKİYET HAKLARI</h2>
          <p style={styles.text}>
            5.1. Platform'a ait tüm içerikler 5846 sayılı FSEK ve 6769 sayılı SMK kapsamındadır...
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 6 - SÖZLEŞMENİN SONA ERMESİ VE MÜCBİR SEBEPLER</h2>
          <p style={styles.text}>
            Şirket, işbu Sözleşme hükümlerine aykırı davranan kullanıcıların erişimini askıya alma veya feshetme hakkına sahiptir...
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 7 - UYGULANACAK HUKUK VE YETKİ</h2>
          <p style={styles.text}>
            Türkiye Cumhuriyeti mevzuatı geçerlidir, İstanbul Anadolu Mahkemeleri yetkilidir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 8 - BİLDİRİMLER VE İLETİŞİM</h2>
          <ul style={styles.list}>
            <li>Ticaret Unvanı: Von Dijital Yazılım Hizmetleri LTD. ŞTİ.</li>
            <li>Adres: Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir</li>
            <li>E-Posta: info@vondigital.com.tr</li>
            <li>Web Sitesi: https://vondigital.com.tr</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Madde 9 - YÜRÜRLÜK</h2>
          <p style={styles.text}>
            İşbu Kullanım Şartları, Platform üzerinde yayınlandığı tarihte yürürlüğe girer. Kullanıma devam eden her Üye, değişiklikleri kabul etmiş sayılır.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Kullanim_Kosullari;
